export const TERTIARY_BUTTON_CLASS =
    "text-base font-medium tracking-tight not-italic leading-7 font-Montserrat text-Primary_Default text-center";
